import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/App';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFoundPage = () => {
  const { language } = useLanguage();

  const content = {
    tr: {
      title: '404',
      subtitle: 'Sayfa Bulunamadı',
      description: 'Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.',
      homeButton: 'Ana Sayfaya Dön',
      backButton: 'Geri Git'
    },
    en: {
      title: '404',
      subtitle: 'Page Not Found',
      description: 'The page you are looking for might have been moved, deleted, or never existed.',
      homeButton: 'Back to Home',
      backButton: 'Go Back'
    }
  };

  const t = content[language];
  const homePath = language === 'en' ? '/en' : '/';

  return (
    <div className="min-h-screen bg-black flex items-center justify-center relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{
          backgroundImage: 'linear-gradient(#FFDD59 1px, transparent 1px), linear-gradient(90deg, #FFDD59 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
        {/* 404 Number */}
        <div className="relative mb-8">
          <h1 className="text-[12rem] md:text-[16rem] font-black text-transparent bg-clip-text bg-gradient-to-b from-[#FFDD59] to-[#FFDD59]/20 leading-none select-none">
            {t.title}
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <Search size={80} className="text-[#FFDD59]/30" />
          </div>
        </div>

        {/* Text */}
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {t.subtitle}
        </h2>
        <p className="text-lg text-gray-400 mb-10 max-w-md mx-auto">
          {t.description}
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={homePath}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#FFDD59] text-black font-bold rounded-full hover:bg-yellow-400 transition-all hover:scale-105 shadow-lg shadow-[#FFDD59]/20"
          >
            <Home size={20} />
            {t.homeButton}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border-2 border-[#FFDD59] text-[#FFDD59] font-bold rounded-full hover:bg-[#FFDD59]/10 transition-all"
          >
            <ArrowLeft size={20} />
            {t.backButton}
          </button>
        </div>

        {/* Brand */}
        <div className="mt-16 opacity-50">
          <p className="text-gray-500 text-sm">PERSONA AGENCY</p>
          <p className="text-gray-600 text-xs mt-1">Istanbul - Dubai</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
